module.exports = __webpack_public_path__ + "media/images/emoticons/crown-02f2c7188ad7bb05eb9e8a90dedb2d41.gif";